angular.module('impactx.manufacturer').controller('ManufacturerDialogCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$sce',
    'searchFilter',
    'ToolbarService',
    'AppConfiguration',
    'SearchService',
    'SearchFilterStorage',
    '$location',
    '$rootScope',
    'SearchFilter',
    '$context',
    'TranslationService',
    ManufacturerDialogCtrl
]);

function ManufacturerDialogCtrl($scope, dataGen, $routeParams, $sce, searchFilter, ToolbarService, AppConfiguration,
                                SearchService, SearchFilterStorage, $location, $rootScope, SearchFilter, $context, TranslationService) {
    var manufacturerCtrl = this;

    var scrollPositionList = 0;
    manufacturerCtrl.manufacturerId = $routeParams.id;
    this.translationService = TranslationService;
    this.panelsInitialized = false;
    this.showScrollTopButton = false;
    this.pageNumber = 1;
    this.displayAllResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    this.informationIsOpen = SearchService.userSearchConfig('informationIsOpen');
    this.showPanelLabel = AppConfiguration.get('showPanelLabels');
    ToolbarService.showSearchFilterToggle();
    this.filterNeedsReset = {value: false};
    manufacturerCtrl.searchWithReset = function (item) {
        manufacturerCtrl.filterNeedsReset.value = true;
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            manufacturerCtrl.filter = freshFilter;
            manufacturerCtrl.filter.manufacturerId = {value: $routeParams.id};
            manufacturerCtrl.filter.dialogFilter = "manufacturer";
            SearchFilterStorage.setManufacturerFilter($routeParams.id, manufacturerCtrl.filter);
            manufacturerCtrl.filter.searchInput.value = searchFilter.searchInput;
            if (item) {
                if (item.isClassification) {
                    manufacturerCtrl.filter.guidingClassification.selected = {id: item.id, value: item.value};
                }
            }
            SearchFilter.setFilters(manufacturerCtrl.filter);
        }
        manufacturerCtrl.searchAll();
    }

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    var storedSearchFilterObject = SearchFilterStorage.getManufacturerFilter($routeParams.id);
    if (storedSearchFilterObject && ($routeParams.useSetFilter || storedSearchFilterObject.searchInputUsed || backButtonUsed)) {
        storedSearchFilterObject.searchInputUsed = false;
        manufacturerCtrl.filter = storedSearchFilterObject;
        searchFilter.searchInput = manufacturerCtrl.filter.searchInput.value;
        var guidingClassification = manufacturerCtrl.filter.guidingClassification;
        if (guidingClassification && guidingClassification.superEntries) {
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        }
        else {
            SearchFilter.setSearchInputClassification(null);
        }
        if(!manufacturerCtrl.filter.productsPerPage)
        {
            manufacturerCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();
        }
        SearchFilter.setFilters(manufacturerCtrl.filter);
        getDialogData(backButtonUsed);
    }
    else {
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            manufacturerCtrl.filter = freshFilter;
            manufacturerCtrl.filter.manufacturerId = {value: $routeParams.id};
            manufacturerCtrl.filter.dialogFilter = "manufacturer";
            SearchFilterStorage.setManufacturerFilter($routeParams.id, manufacturerCtrl.filter);
            searchFilter.searchInput = manufacturerCtrl.filter.searchInput.value;
            SearchFilter.setFilters(manufacturerCtrl.filter);
            getDialogData();
        }
        else {
            var result = {};
            dataGen.getData(result, {}, "/search/filter", null, true).then(function () {
                SearchFilterStorage.setFreshFilter(result.data);
                manufacturerCtrl.filter = result.data;
                manufacturerCtrl.filter.manufacturerId = {value: $routeParams.id};
                manufacturerCtrl.filter.dialogFilter = "manufacturer";
                SearchFilterStorage.setManufacturerFilter($routeParams.id, manufacturerCtrl.filter);
                if ($location.path() === currentLocation) {
                    //only if we are still on the vCatalog page.
                    searchFilter.searchInput = manufacturerCtrl.filter.searchInput.value;
                    SearchFilter.setFilters(manufacturerCtrl.filter);
                    getDialogData()
                }
            });
        }
    }

    function getDialogData(backButtonUsed) {
        return dataGen.getData($scope, {id: $routeParams.id}, "/manufacturer/view").then(function () {
            manufacturerCtrl.searchAll(true).then(function () {
                manufacturerCtrl.panelsInitialized = true;
                if(backButtonUsed) {
                    SearchFilterStorage.scrollToSearchScrollPosition("manufacturer", '#search-view');
                }
            });
            $scope.themeWorldActive = $scope.data.themeWorldActive;
            $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;
            $scope.description = $sce.trustAsHtml($scope.data.description);
            defineButtons();
        });
    }

    manufacturerCtrl.showName1 = function () {
        return !angular.equals($scope.data.name, $scope.data.address.name1.value);
    };

    manufacturerCtrl.showScrollTop = function (showScrollTop, scrollPosition) {
        manufacturerCtrl.showScrollTopButton = showScrollTop;
        scrollPositionList = scrollPosition;
    };

    manufacturerCtrl.searchProducts = function (index, selectedSort) {
        manufacturerCtrl.filter.productPageNumber = index;
        manufacturerCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();

        if (selectedSort) {
            manufacturerCtrl.filter.sort.selected = selectedSort;
        }
        return SearchService.searchProducts(manufacturerCtrl.filter.productPageNumber).then(function (searchResults) {
            if (searchResults) {
                angular.extend(manufacturerCtrl, searchResults);
            }
        })
    };

    manufacturerCtrl.searchAll = function (onInit) {
        if (!onInit && manufacturerCtrl.filter) {
            manufacturerCtrl.filter.productPageNumber = 1;
        }
        return SearchService.searchAll().then(function (searchResult) {
            angular.extend(manufacturerCtrl, searchResult);
            manufacturerCtrl.createScrollList();
            $scope.noSearchResults = searchResult.products.length === 0;
            $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;
        });
    };

    manufacturerCtrl.scrollToTop = function () {
        angular.element('#search-view').animate({
            scrollTop: scrollPositionList
        }, 200);
    };

    manufacturerCtrl.toggleInformation = function () {
        manufacturerCtrl.informationIsOpen = !manufacturerCtrl.informationIsOpen;
    };

    manufacturerCtrl.createScrollList = function () {
        $scope.scrollList = [];
        var numberOfPros = manufacturerCtrl.numberOfProducts;
        if (numberOfPros > 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.products})
        }
        if (numberOfPros == 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.product})
        }
        if ($scope.scrollList.length > 0) {
            $scope.scrollList.unshift({id: "header", label: $scope.trns.headerData});
        }

        ToolbarService.setScrollMenu($scope.scrollList)
    };

    function defineButtons() {
        ToolbarService.setButtons([]);
    }

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        if (newRoute.originalPath !== "/search") {
            SearchFilter.setSearchInputClassification(null);
            searchFilter.searchInput = "";
            SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
        }
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchFilterPlaceHolder(null);
            SearchFilterStorage.setSearchScrollPosition("manufacturer", document.getElementById('search-view').scrollTop);
        }
    });

    $scope.$on('$destroy', function () {
        SearchService.setUserSearchConfigParameter('informationIsOpen', manufacturerCtrl.informationIsOpen);
        ToolbarService.hideSearchFilterToggle();
    });

    manufacturerCtrl.anyResults = function () {
        return manufacturerCtrl.products && manufacturerCtrl.products.length > 0;
    };

    manufacturerCtrl.showNoResultsHint = function () {
        return !$context.hasActiveThemeWorldSearch || !$context.hasActiveThemeWorldSearch.value;
    }

    this.searchTerm = function (term) {
        SearchFilter.setFilterIdentifier();
        searchFilter.searchInput = term;

        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter())

        SearchFilter.getFilters().manufacturerId = {value: $routeParams.id};
        SearchFilter.getFilters().dialogFilter = "manufacturer";
        SearchFilterStorage.setManufacturerFilter($routeParams.id, SearchFilter.getFilters());

        searchFilter.resetDetailFilter().then(function () {
            var filterData = {};
            if ($context.hasActiveShopView.value) {
                searchFilter.listSearch.value = true;
            }
            SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
            SearchFilter.getFilters().searchInputUsed = true;
            manufacturerCtrl.searchWithReset();
        });
    };
}